/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row2_KbInputs */

const en_mk_cmp_row2_kb = /** @type {(inputs: Mk_Cmp_Row2_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every division in the company`)
};

const id_mk_cmp_row2_kb = /** @type {(inputs: Mk_Cmp_Row2_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua divisi perusahaan`)
};

/**
* | output |
* | --- |
* | "Every division in the company" |
*
* @param {Mk_Cmp_Row2_KbInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row2_kb = /** @type {((inputs?: Mk_Cmp_Row2_KbInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row2_KbInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row2_kb(inputs)
	return en_mk_cmp_row2_kb(inputs)
});